// extracted by mini-css-extract-plugin
export default {"container":"RMSPageMetadata_container__8O5Vg","content":"RMSPageMetadata_content__uhbi0","breadcrumb":"RMSPageMetadata_breadcrumb__LLLV8","date":"RMSPageMetadata_date__uD3LC"};